import { AssetTypes } from "./types";

export type AssetTypeLabel = "canvas" | "zap" | "table" | "tableView" | "other";

const SUPPORTED_ASSET_TYPES = new Set<string>([
  AssetTypes.Canvas,
  AssetTypes.Zap,
  AssetTypes.Table,
  AssetTypes.TableView,
]);

/** Returns the shared asset type, or "other" for mixed or unsupported ids. */
export function getAssetTypeLabel(
  typedAssetIds: readonly string[],
): AssetTypeLabel {
  const assetTypes = new Set(
    typedAssetIds.map((typedAssetId) => typedAssetId.split(":", 1)[0]),
  );

  if (assetTypes.size !== 1) {
    return "other";
  }

  const [assetType] = assetTypes;
  return SUPPORTED_ASSET_TYPES.has(assetType)
    ? (assetType as Exclude<AssetTypeLabel, "other">)
    : "other";
}
